import React from "react"
import {CmExternalLinkType} from "../types";
import CCOLink from "./CCOLink";
import {isTargetDownload} from "../../utility/navigationUtil";

interface Props {
    externalMenuLink?: boolean
    children?: JSX.Element
    name?: string
    noLinkIcon?: boolean
    onClick?: any
    openInTab?: boolean
    target?: any;
    type?: string
    dataCypress?: string
    className?: string
    style?: React.CSSProperties
    ariaCurrent?: string
    ariaLabel?: string
}

const CCOLinkable = React.forwardRef<HTMLAnchorElement, Props>(function CCOLinkable(props, ref) {
    // Do not show external link icon if it's a link to a download
    const noLinkIcon = props.noLinkIcon || isTargetDownload(props.target)

    if (props.target) {
        const isTeaserType = ["SOSTeaser", "CMTeaser"].includes(props.target.type);

        const isExternal =
            props.type === "CMExternalLink" ||
            (isTeaserType && props.target.teaserTarget?.type === "CMExternalLink") ||
            Boolean(props.externalMenuLink);

        if (props.target.type === "CMExternalLink") {
            const externalTarget = props.target as CmExternalLinkType
            return <CCOLink ref={ref} className={props.className} style={props.style}
                            dataCypress={props.dataCypress} openInTab={true} target={externalTarget} type={props.type} noLinkIcon={noLinkIcon}
                            onClick={props.onClick} externalMenuLink={props.externalMenuLink} ariaCurrent={props.ariaCurrent} ariaLabel={props.ariaLabel} isExternalTarget={true}>{props.children}</CCOLink>
        } else {
            const newTab = props.target.type === "SOSWimmelbild" ? true : props.openInTab
            return <CCOLink ref={ref} className={props.className} style={props.style}
                            dataCypress={props.dataCypress}
                            openInTab={newTab}
                            target={props.target}
                            name={props.name}
                            type={props.type}
                            noLinkIcon={noLinkIcon}
                            onClick={props.onClick}
                            ariaCurrent={props.ariaCurrent}
                            ariaLabel={props.ariaLabel}
                            isExternalTarget={isExternal}>{props.children}</CCOLink>
        }
    } else {
        return props.children ? props.children : null
    }
});

export default CCOLinkable